import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const modalApi = createApi({
    reducerPath: 'modalApi',
    tagTypes: ['Modal'],
    baseQuery: fetchBaseQuery({
      baseUrl: api,
      prepareHeaders: (headers) => {
        const token = localStorage.getItem("token");
        if(token) headers.set("token", token);
        return headers;
      }
    }),
    endpoints: (builder) => ({

      getModal: builder.mutation({
        query: (params) => ({
          url: "/api/modals/get",
          method: "GET",
          params
        }),
        invalidatesTags: ["Modal"]
      }),

      getModals: builder.query({
        query: () => ({
          url: "/api/modals/get",
          method: "GET"
        }),
        providesTags: ["Modal"]
      }),


      createModal: builder.mutation({
        query: () => ({
          url: '/api/modals/create',
          method: 'POST'
        }),
        invalidatesTags: ["Modal"]
      }),

      updateModal: builder.mutation({
        query: (data) => ({
          url: '/api/modal/update',
          method: 'POST',
          body: data
        }),
        invalidatesTags: ["Modal"]
      }),

      activateModal: builder.mutation({
        query: (data) => ({
          url: '/api/modal/activate',
          method: 'POST',
          body: data
        }),
        invalidatesTags: ["Modal"]
      })

    }),
})

export const {
  useUpdateModalMutation,
  useGetModalMutation,
  useGetModalsQuery,
  useActivateModalMutation,
  useCreateModalMutation
} = modalApi;